/* eslint-disable object-curly-newline */
import update from 'immutability-helper';
import naturalCompare from 'string-natural-compare';
import { indexById } from '../indexById/indexById';
import { get as getId } from '../localId/localId';

export const ADD_LOCAL_SUBCONTRACTOR = 'ADD_LOCAL_SUBCONTRACTOR';
export const REMOVE_LOCAL_SUBCONTRACTOR = 'REMOVE_LOCAL_SUBCONTRACTOR';
export const API_LOAD_SUBCONTRACTORS = 'API_LOAD_SUBCONTRACTORS';
export const API_REMOVE_SUBCONTRACTOR = 'API_REMOVE_SUBCONTRACTOR';
export const API_CREATE_SUBCONTRACTOR = 'API_CREATE_SUBCONTRACTOR';
export const API_UPDATE_SUBCONTRACTOR = 'API_UPDATE_SUBCONTRACTOR';

const API_LOAD_SUBCONTRACTORS_FAILED = 'API_LOAD_SUBCONTRACTORS_FAILED';
const API_LOAD_SUBCONTRACTORS_LOADING = 'API_LOAD_SUBCONTRACTORS_LOADING';
const API_LOAD_SUBCONTRACTORS_LOADED = 'API_LOAD_SUBCONTRACTORS_LOADED';
const API_REMOVE_SUBCONTRACTOR_FAILED = 'API_REMOVE_SUBCONTRACTOR_FAILED';
const API_REMOVE_SUBCONTRACTOR_LOADING = 'API_REMOVE_SUBCONTRACTOR_LOADING';
const API_REMOVE_SUBCONTRACTOR_SUCCESS = 'API_REMOVE_SUBCONTRACTOR_SUCCESS';
const API_CREATE_SUBCONTRACTOR_FAILED = 'API_CREATE_SUBCONTRACTOR_FAILED';
const API_CREATE_SUBCONTRACTOR_LOADING = 'API_CREATE_SUBCONTRACTOR_LOADING';
const API_CREATE_SUBCONTRACTOR_SUCCESS = 'API_CREATE_SUBCONTRACTOR_SUCCESS';
const API_UPDATE_SUBCONTRACTOR_FAILED = 'API_UPDATE_SUBCONTRACTOR_FAILED';
const API_UPDATE_SUBCONTRACTOR_LOADING = 'API_UPDATE_SUBCONTRACTOR_LOADING';
const API_UPDATE_SUBCONTRACTOR_SUCCESS = 'API_UPDATE_SUBCONTRACTOR_SUCCESS';

const defaultState = { subContractors: [], loading: false };
const emptySubContractor = () => ({ id: getId(), name: '', isRemoving: false });
const mapDefaults = subContractor => ({ ...emptySubContractor(), ...subContractor });

export const reducer = (state = defaultState, { type, response, id, replaceId, resource }) => {
  switch (type) {
    case API_LOAD_SUBCONTRACTORS_LOADED:
      return update(state, {
        loading: { $set: false },
        subContractors: { $set: response.map(mapDefaults) },
      });
    case API_LOAD_SUBCONTRACTORS_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_SUBCONTRACTORS_FAILED:
      return update(state, { loading: { $set: false } });
    case ADD_LOCAL_SUBCONTRACTOR:
      return update(state, { subContractors: { $push: [emptySubContractor()] } });
    case API_REMOVE_SUBCONTRACTOR_SUCCESS:
    case REMOVE_LOCAL_SUBCONTRACTOR:
      return update(state, { subContractors: { $splice: [[indexById(id, state.subContractors), 1]] } });
    case API_REMOVE_SUBCONTRACTOR_FAILED:
      return update(state, { subContractors: { [indexById(id, state.subContractors)]: { removing: { $set: false } } } });
    case API_REMOVE_SUBCONTRACTOR_LOADING:
      return update(state, { subContractors: { [indexById(id, state.subContractors)]: { removing: { $set: true } } } });
    case API_CREATE_SUBCONTRACTOR_FAILED:
      return update(state, { subContractors: { [indexById(resource.id, state.subContractors)]: { saving: { $set: false } } } });
    case API_CREATE_SUBCONTRACTOR_LOADING:
      return update(state, { subContractors: { [indexById(resource.id, state.subContractors)]: { saving: { $set: true } } } });
    case API_CREATE_SUBCONTRACTOR_SUCCESS:
      return update(state, { subContractors: { $splice: [[indexById(replaceId, state.subContractors), 1, response]] } });
    default:
      return state;
  }
};

export const subContractors = state => state.subContractors.subContractors.sort((a, b) => naturalCompare.caseInsensitive(a.name, b.name));
export const loading = state => state.subContractors.loading;

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/subContractor/subContractor.reducer.js